import { withInitAction, prepareComponent } from '@mediamonks/react-redux-component-init';
import Checkout from '../../../../Payment/components/templates/Checkout';
import PackageSelection from './PackageSelection';

const addInitAction = withInitAction({
  prepared: ({}, dispatch) => dispatch(prepareComponent(Checkout)),
});

export default addInitAction(PackageSelection);
